import React from 'react';

const PinMarker: React.FC = () => (
    <React.Fragment>
        <g>
            <path d="M 3.758 24.015 C 1.692 21.166 0.482 17.789 0.271 14.281 L 0.305 14.281 C 0.281 13.985 0.271 13.692 0.271 13.391 C 0.271 6.039 6.857 0.078 14.986 0.078 C 23.113 0.078 29.699 6.039 29.699 13.391 C 29.699 13.688 29.688 13.979 29.665 14.281 L 29.699 14.281 C 29.368 17.789 28.11 21.149 26.053 24.015 C 22.728 28.752 19.025 33.213 14.982 37.356 C 10.872 33.232 7.116 28.769 3.758 24.015 Z" />
        </g>
    </React.Fragment>
)

export default PinMarker;
